/* Coût horaire de capacité (CCR) — la formule, à UN seul endroit.

   Elle vivait dans le récit du CCR, en ligne. Le récit People en a eu besoin à
   son tour (2026-08-26) pour montrer l'évolution des deux taux : la recopier
   aurait donné deux CCR qui divergent au premier changement de règle, sur deux
   écrans que le même dirigeant lit à cinq minutes d'intervalle.

   La route est celle de la cascade « comptable » : on part des charges de
   personnel telles qu'elles sont portées en paie, on retire les congés spéciaux
   (hors périmètre analytique, décision CFO de juillet 2026), on rend les frais
   spécifiques à leur groupe et on répartit le reste. Elle aboutit au centime au
   même total que la route analytique (productif + gestion + supervision), ce
   qui est justement la réconciliation posée par la cascade.

   Dénominateur : la capacité pratique (TR), dénominateur Kaplan stable. */

const num = (v) => Number(v) || 0;

/**
 * @param {object} cascadeTotals  `totals` de /tdabc/personnel-cost-cascade
 * @param {number} indirectBase   base de charges indirectes de l'année (francs)
 * @returns {{tr: number, costTotal: number, ccr: number|null}}
 *          `ccr` vaut null sans capacité pratique : une division par zéro se
 *          dit absente, elle ne se remplace pas par un zéro qui se lirait
 *          comme un coût nul.
 */
export function computeCcr(cascadeTotals, indirectBase) {
  const t = cascadeTotals || {};
  const tr = num(t.production_hours);
  const specific = num(t.specific_indirect);
  /* Les frais SPÉCIFIQUES sont saisis sur un groupe : ils sortent de la base à
     répartir, sinon ils comptent deux fois (une fois sur leur groupe, une fois
     dans le solde mutualisé). */
  const general = num(t.expenses) + Math.max(0, num(indirectBase) - specific);
  const costTotal = num(t.personnel) - num(t.absenteism) + specific + general;
  return { tr, costTotal, ccr: tr > 0 ? costTotal / tr : null };
}
